import type { FC, ReactNode } from 'react'
import ProductDetails from './ProductDetails'
import ProductRewards from './ProductRewards'
import type { CartProduct } from '../../shopping-cart/provider/types'
import { useShoppingCartOpsDispatch } from '../../shopping-cart/ShoppingCartProvider'
import { TrashIcon } from '@heroicons/react/24/outline'
import type { GetShopItems_getShopItems } from '@g4g/graphql/src/shop/__generated__/GetShopItems'

const ProductRemove: FC<{ shopItem: GetShopItems_getShopItems }> = ({ shopItem }) => {
  const dispatch = useShoppingCartOpsDispatch()

  return (
    <div className="flex justify-end">
      <button
        data-cy="shop-product-row-remove-btn"
        className="flex items-center py-4 space-x-1 sm:py-2 text-white/80 hover:text-white"
        onClick={() => dispatch({ type: 'remove-from-cart', item: shopItem, purge: true })}
      >
        <TrashIcon className="w-4 h-4" />
        <span>Remove</span>
      </button>
    </div>
  )
}

const ProductRow: FC<{
  product: CartProduct
  isRemovable?: boolean
  shine?: boolean
  variant?: 'cart' | 'history'
  children?: ReactNode
}> = ({ product, isRemovable, shine, variant = 'cart', children }) => {
  return (
    <div className="flex flex-col space-y-4 grow">
      <div className="flex flex-col justify-end w-full space-y-3 xl:flex-row xl:space-y-0">
        {/* Left side (product details) */}
        <ProductDetails product={product} variant={variant}>
          {children}
        </ProductDetails>
        {/* Right side (product rewards) */}
        <ProductRewards product={product} shine={shine} />
      </div>
      {isRemovable && <ProductRemove shopItem={product.product} />}
    </div>
  )
}

export default ProductRow
